import React from "react";
import { type IconType } from "react-icons";

interface ContactInfoItemProps {
  icon: IconType;
  children: React.ReactNode;
}

/**
 * Contact Info Item - Icon box with content
 * Icon box: 40x40 with white border and gradient background
 * Content: 16px white text with 15px gap from icon
 */
export default function ContactInfoItem({
  icon: Icon,
  children,
}: ContactInfoItemProps) {
  return (
    <div className="flex items-center gap-[15px]">
      <div className="from-brand-red to-brand-dark-red flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-[5px] border border-white bg-linear-to-br">
        <Icon className="h-5 w-5 text-white" />
      </div>
      <div className="font-raleway text-start text-base text-white">
        {children}
      </div>
    </div>
  );
}
